import { render, staticRenderFns } from "./TopicsPage.vue?vue&type=template&id=a7e2efaa&scoped=true&"
import script from "./TopicsPage.vue?vue&type=script&lang=js&"
export * from "./TopicsPage.vue?vue&type=script&lang=js&"
import style0 from "./TopicsPage.vue?vue&type=style&index=0&id=a7e2efaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e2efaa",
  null
  
)

export default component.exports